import { Slider, SliderContainer } from 'components/Slider';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Creators as FormCreators } from '../../store/ducks/serviceForm';

import { device } from '../../styles/stylesheets';

import {
  CardServiceCustom,
  SliderPreviousCustom,
  SliderNextCustom,
} from './styles';

function ServicesPopular() {
  const dispatch = useDispatch();

  const companySource = useSelector(state => state.company.data.source);
  const companyId = useSelector(state => state.company.data.id);
  const services = useSelector(state => state.services.data);

  const popular = [168, 169, 295, 6, 7, 1, 4];
  const servicesPopular = services.length > 0 && (
    services.filter(service => popular.indexOf(service.id) >= 0)
  );

  function _openServiceForm(payload) {
    dispatch(FormCreators.openForm(payload));
  }

  return (
    <SliderContainer>
      <Slider
        slidesToShow="auto"
        slidesToScroll={1}
        hasArrows
        duration={1.3}
        draggable
        dragVelocity={1}
        itemWidth={228}
        exactWidth
        responsive={[
          {
            breakpoint: device.screen.tablet,
            settings: {
              itemWidth: 256,
            },
          },
        ]}
      >
        {
          servicesPopular && servicesPopular.length > 0 && servicesPopular.map(service => (
            <CardServiceCustom
              key={`service-popular-${service.id}`}
              service={service}
              openForm={() => _openServiceForm({
                open: true,
                isOpen: true,
                source: companySource,
                company_id: companyId,
                serviceId: service.id,
              })
              }
              variant="popular"
            />
          ))
        }
      </Slider>
      <SliderPreviousCustom>«</SliderPreviousCustom>
      <SliderNextCustom>»</SliderNextCustom>
    </SliderContainer>
  );
}

export default ServicesPopular;
